module.exports = ".display-footer {\n  position: relative;\n  margin-top: 164px; }\n  .display-footer .partner-links a {\n    padding: 8px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/jssi-footer/jssi-footer.component.scss
// module id = ./src/app/shared-components/jssi-footer/jssi-footer.component.scss
// module chunks = main